// extracted by mini-css-extract-plugin
export default {"container":"message-time_container__s+yD3","--not-sent":"message-time_--not-sent__cePQp"};